import { VerifyYourIdentityPage } from "./VerifyYourIdentityPage";
export default VerifyYourIdentityPage;
